import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { cn } from '../lib/utils';
type Props = {
  children: React.ReactNode;
  className?: string;
  href?: string;
  size?: 'md' | 'lg';
};
export const CHECKOUT_URL = 'https://100-ai-prompts-for-private-security.impultienda.ar/checkout';
export function CTAButton({
  children,
  className = '',
  href = CHECKOUT_URL,
  size = 'lg'
}: Props) {
  const pad = size === 'lg' ? 'min-h-[64px] px-7 py-4 text-[16px]' : 'min-h-[56px] px-6 py-3.5 text-[15px]';
  return <a href={href} className={cn('group inline-flex w-full max-w-[380px] items-center justify-center gap-2 rounded-xl bg-teal text-center font-extrabold uppercase leading-tight tracking-wide text-ink shadow-[0_12px_36px_-12px_rgba(224,180,76,0.7)] ring-1 ring-gold/50 transition-[transform,background-color,box-shadow] duration-200 ease-out hover:-translate-y-0.5 hover:bg-teal-soft hover:shadow-[0_18px_44px_-12px_rgba(224,180,76,0.85)] focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-ink', pad, className)} data-id="element-54" data-mp="2oz8co2typms1">
      {children}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-55" data-mp="1dcbaerrffcv8" />
    </a>;
}